<template>
  <sl-side-panel v-model="modalVisible" :mask-closable="false" :title="itemTitle" @close="close">
    <sl-amap @ready="ready" />
  </sl-side-panel>
</template>
<script>
import dics from './dics'
import { wgs2gcj, gcj2wgs } from '@/util/map/proj'

var SimpleMarker

const createSimpleMarker = (option) => new Promise((resolve) => {
  if (SimpleMarker) {
    resolve(new SimpleMarker(option))
  } else {
    AMapUI.loadUI(['overlay/SimpleMarker'], function(sm) {
      SimpleMarker = sm
      resolve(new SimpleMarker(option))
    })
  }
})

const styles = {
  0: {
    iconLabel: {
      //普通文本
      innerHTML: '',
      //设置样式
      style: {
        color: '#fff',
        fontSize: '100%',
        marginTop: '2px'
      }
    },
    iconStyle: 'green',
  },
  1: {
    iconLabel: {
      //普通文本
      innerHTML: '终',
      //设置样式
      style: {
        color: '#fff',
        fontSize: '120%',
        marginTop: '2px'
      }
    },
    iconStyle: 'red',
  }
}

export default {
  components: {},
  data() {
    return {
      centerData: ['', ''],
      id: null,
      loading: false,
      isCreate: true,
      modalVisible: false,
      timer: null
    }
  },

  computed: {
    itemTitle() {
      return '实时位置'
    }
  },
  beforeDestroy() {
    this.close()
  },

  methods: {
    destroyTimer() {
      if(this.timer){
        clearInterval(this.timer)
        this.timer = null
      }
    },
    close() {
      for(let i in this.pois){
        this.pois[i].setMap(null)
      }
      this.pois = {}
      this.destroyTimer()
    },

    init(id) {
      this.id = id
      this.modalVisible = true
      if (this.id) {
        this.query()
        this.pois = {}
      }
    },
    ready(map) {
      this.map = map
    },
    query() {
      if( !this.modalVisible ) return

      this.$request.logisticsLoction(this.id).then(resp => {
        if( !this.modalVisible ) return

        if (resp.data) {
          resp.data.forEach((item) => {
            if( !this.pois[item.type] ){
              createSimpleMarker({
                position: wgs2gcj(item.longitude, item.latitude),
                map: this.map,
                ...styles[item.type]
              }).then(marker => {
                this.pois[item.type] = marker
              })
            }else{
              this.pois[item.type].setPosition(new AMap.LngLat(...wgs2gcj(item.longitude, item.latitude)))
            }
          })
        }

        this.timer = setTimeout(() => {
          this.query()
        }, 2000)
      })
    }
  }
}

</script>